import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { baseurl } from "../../baseurl";

// ── Inline mock for preview – remove in production ──────────────────────────
const MOCK = {
  arrivalTime: "",
  bookingFee: "0",
  busType: "Electric A/C Seater (2+2)",
  cancellationPolicy: "0:3:100:0;3:4:100:0;4:12:50:0;12:24:25:0;24:72:15:0;72:168:15:0;168:-1:15:0",
  dateOfIssue: "2026-03-06T21:27:06+05:30",
  destinationCity: "Delhi",
  displayPnr: "52974",
  doj: "2026-03-07T00:00:00+05:30",
  dropLocation: "ISBT Kashmere Gate",
  dropLocationAddress: "ISBT Kashmere Gate, PLATFORM NO 49 to 51",
  dropLocationLandmark: "Isbt Kashmere Gate, Platform No. 49 To 51",
  dropLocationLatitude: "28.666823",
  dropLocationLongitude: "77.22933",
  dropTime: "810",
  firstBoardingPointTime: "540",
  inventoryItems: [
    { baseFare:"339.00", fare:"339.00", grandTotalFare:"355.95", serviceTax:"16.95", operatorServiceCharge:"0.00", seatName:"1", passenger:{ name:"Sadham", age:"46", gender:"MALE", mobile:"9932370928", title:"Mr", primary:"true" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"339.00",refundableValue:"339.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"16.95",refundableValue:"16.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"355.95",refundableValue:"355.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"339.00", fare:"339.00", grandTotalFare:"355.95", serviceTax:"16.95", operatorServiceCharge:"0.00", seatName:"5", passenger:{ name:"Savita", age:"40", gender:"FEMALE", mobile:"9932370928", title:"Mrs", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"339.00",refundableValue:"339.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"16.95",refundableValue:"16.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"355.95",refundableValue:"355.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"359.00", fare:"359.00", grandTotalFare:"376.95", serviceTax:"17.95", operatorServiceCharge:"0.00", seatName:"10", passenger:{ name:"Sahani", age:"18", gender:"MALE", mobile:"9932370928", title:"Mr", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"359.00",refundableValue:"359.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"17.95",refundableValue:"17.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"376.95",refundableValue:"376.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"359.00", fare:"359.00", grandTotalFare:"376.95", serviceTax:"17.95", operatorServiceCharge:"0.00", seatName:"6", passenger:{ name:"Maya", age:"66", gender:"FEMALE", mobile:"9932370928", title:"Mrs", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"359.00",refundableValue:"359.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"17.95",refundableValue:"17.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"376.95",refundableValue:"376.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
  ],
  MTicketEnabled: "true",
  partialCancellationAllowed: "true",
  pickUpContactNo: "8826060313",
  pickUpLocationAddress: "Kashyap Ashram Haridwar",
  pickupLocation: "Kashyap ashram (Pickup Van/Bus)",
  pickupLocationLandmark: "Nh 58 Delhi Dehradun Highway",
  pickupLatitude: "29.935412",
  pickupLongitude: "78.146949",
  pickupTime: "540",
  pnr: "TS260306212241980421RCKX/52974/Dehradun-Delhi A",
  primeDepartureTime: "540",
  reschedulingPolicy: { reschedulingCharge: "-1", windowTime: "0" },
  serviceCharge: "0.00",
  serviceStartTime: "2026-03-07 09:00:00",
  sourceCity: "Haridwar",
  status: "BOOKED",
  tin: "4BSK9PA2",
  travels: "Ezy Go Bus (10)",
  tripCode: "10",
  vaccinatedBus: "false",
  vaccinatedStaff: "false",
  vendorPnr: "TS260306212241980421RCKX",
  amount: "1547.00",
  cancellationCalculationTimestamp: "2026-03-07 09:00:00",
};

// ── Helpers ──────────────────────────────────────────────────────────────────
const minsToTime = (dateString) => {
  if (!dateString) return "--:--";
  try {
    const timePart = dateString.split(" ")[1];
    return timePart ? timePart.substring(0, 5) : "--:--";
  } catch {
    return "--:--";
  }
};

const fmt = (v) => parseFloat(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const parsePolicy = (s) =>
  s ? s.split(";").map((r) => { const [a, b, c] = r.split(":"); return { hMin: a, hMax: b, pct: c }; }) : [];

const formatDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

const formatDOJ = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  return isNaN(d.getTime()) ? dateString : d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

// ── Styles ───────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --ink: #0f1923;
    --ink2: #3d4f5c;
    --ink3: #7a8fa0;
    --paper: #f8f6f1;
    --white: #ffffff;
    --accent: #1a4a6b;
    --accent2: #c8973a;
    --green: #1a6b4a;
    --red: #8b1a1a;
    --border: #ddd8ce;
    --shadow: 0 8px 40px rgba(15,25,35,0.12);
  }

  body { background: #e8e4dd; font-family: 'DM Sans', sans-serif; color: var(--ink); }

  .inv-page {
    min-height: 100vh;
    padding: 32px 16px 48px;
    background: #e8e4dd;
    background-image: 
      repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(0,0,0,0.015) 40px, rgba(0,0,0,0.015) 41px),
      repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(0,0,0,0.015) 40px, rgba(0,0,0,0.015) 41px);
  }

  .top-bar {
    max-width: 860px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .btn { display: inline-flex; align-items: center; gap: 6px; border: none; cursor: pointer; font-family: 'DM Sans', sans-serif; font-weight: 500; border-radius: 6px; transition: all .2s; font-size: 13px; }
  .btn-ghost { background: rgba(255,255,255,0.7); color: var(--ink); padding: 8px 14px; border: 1px solid var(--border); }
  .btn-ghost:hover { background: white; }
  .btn-danger { background: #fff0f0; color: var(--red); padding: 8px 16px; border: 1px solid #f5c6c6; }
  .btn-danger:hover { background: #ffe0e0; }
  .btn-primary { background: var(--accent); color: white; padding: 8px 20px; }
  .btn-primary:hover { background: #153d5a; }

  .invoice {
    max-width: 860px;
    margin: 0 auto;
    background: var(--white);
    border-radius: 4px;
    box-shadow: var(--shadow);
    overflow: hidden;
    border: 1px solid var(--border);
  }

  /* ── Header ── */
  .inv-header {
    background: var(--accent);
    padding: 28px 36px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
    align-items: start;
  }
  .brand-name { font-family: 'Playfair Display', serif; font-size: 26px; color: white; letter-spacing: 0.5px; }
  .brand-sub { font-size: 11px; color: rgba(255,255,255,0.55); letter-spacing: 2px; text-transform: uppercase; margin-top: 2px; }
  .brand-contact { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 8px; line-height: 1.8; }

  .doc-meta { text-align: right; }
  .doc-title { font-family: 'Playfair Display', serif; font-size: 13px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 3px; }
  .doc-tin { font-family: 'DM Mono', monospace; font-size: 22px; color: white; font-weight: 500; letter-spacing: 2px; }
  .status-chip { display: inline-block; margin-top: 8px; padding: 3px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; }
  .chip-booked { background: rgba(26,107,74,0.3); color: #7fffc4; border: 1px solid rgba(127,255,196,0.3); }
  .chip-cancelled { background: rgba(139,26,26,0.4); color: #ffb3b3; border: 1px solid rgba(255,179,179,0.3); }

  /* ── Journey strip ── */
  .journey-strip {
    background: var(--paper);
    border-bottom: 1px solid var(--border);
    padding: 24px 36px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 16px;
  }
  .city-label { font-size: 10px; color: var(--ink3); text-transform: uppercase; letter-spacing: 2px; margin-bottom: 4px; }
  .city-name { font-family: 'Playfair Display', serif; font-size: 22px; color: var(--ink); }
  .city-time { font-family: 'DM Mono', monospace; font-size: 30px; color: var(--accent); font-weight: 500; margin-top: 2px; }
  .city-date { font-size: 11px; color: var(--ink3); margin-top: 4px; }

  .journey-mid { text-align: center; }
  .dur-pill {
    background: var(--white);
    border: 1px solid var(--border);
    border-radius: 20px;
    padding: 5px 14px;
    font-size: 11px;
    color: var(--ink2);
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }
  .route-line {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--border), transparent);
    margin: 8px 0;
    position: relative;
  }
  .route-line::before, .route-line::after {
    content: '';
    position: absolute;
    top: -3px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--accent2);
  }
  .route-line::before { left: 0; }
  .route-line::after { right: 0; }

  .dest { text-align: right; }

  /* ── Operator bar ── */
  .operator-bar {
    background: var(--white);
    border-bottom: 1px solid var(--border);
    padding: 14px 36px;
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
    align-items: center;
  }
  .op-item { display: flex; flex-direction: column; }
  .op-label { font-size: 9px; color: var(--ink3); text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 2px; }
  .op-value { font-size: 13px; font-weight: 500; color: var(--ink); }
  .op-value.mono { font-family: 'DM Mono', monospace; font-size: 12px; }
  .badge-small {
    display: inline-flex; align-items: center; gap: 4px;
    background: #e8f5ee; color: var(--green);
    border: 1px solid #b3dfc7;
    padding: 2px 8px; border-radius: 12px;
    font-size: 10px; font-weight: 600;
  }

  /* ── Body ── */
  .inv-body { padding: 32px 36px; display: grid; grid-template-columns: 1fr 340px; gap: 32px; }
  @media (max-width: 700px) { .inv-body { grid-template-columns: 1fr; } .journey-strip { grid-template-columns: 1fr; } .inv-header { grid-template-columns: 1fr; } }

  /* ── Section ── */
  .section { margin-bottom: 28px; }
  .sec-title {
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    color: var(--ink3);
    font-weight: 600;
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sec-title svg { opacity: .5; }

  /* ── Passenger cards ── */
  .pax-card {
    border: 1px solid var(--border);
    border-radius: 4px;
    display: grid;
    grid-template-columns: 1fr auto;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .pax-info { padding: 12px 16px; }
  .pax-name { font-weight: 600; font-size: 15px; color: var(--ink); }
  .pax-name.primary::after { content: 'PRIMARY'; font-size: 8px; background: var(--accent2); color: white; padding: 1px 6px; border-radius: 3px; margin-left: 8px; font-weight: 700; letter-spacing: 1px; vertical-align: middle; }
  .pax-meta { font-size: 12px; color: var(--ink3); margin-top: 3px; }
  .pax-mobile { font-size: 11px; color: var(--ink3); margin-top: 2px; font-family: 'DM Mono', monospace; }
  .pax-seat {
    background: var(--accent);
    color: white;
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgba(255,255,255,0.1);
  }
  .seat-lbl { font-size: 8px; text-transform: uppercase; letter-spacing: 1.5px; opacity: .6; }
  .seat-num { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 700; line-height: 1; }

  .pax-fare-row {
    padding: 8px 16px;
    border-top: 1px dashed var(--border);
    display: flex;
    gap: 20px;
    font-size: 11px;
    color: var(--ink3);
    background: #fafafa;
  }
  .pax-fare-row span b { color: var(--ink); font-weight: 600; }

  /* ── Stations ── */
  .station-box {
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 14px 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .station-box.boarding { border-left: 3px solid var(--accent); }
  .station-box.dropping { border-left: 3px solid var(--accent2); }
  .station-type { font-size: 9px; text-transform: uppercase; letter-spacing: 2px; font-weight: 700; margin-bottom: 6px; }
  .station-type.boarding { color: var(--accent); }
  .station-type.dropping { color: var(--accent2); }
  .station-name { font-weight: 600; font-size: 14px; color: var(--ink); }
  .station-addr { font-size: 11px; color: var(--ink3); margin-top: 3px; line-height: 1.5; }
  .station-landmark { font-size: 10px; color: var(--ink3); margin-top: 2px; font-style: italic; }
  .station-phone { font-size: 11px; color: var(--ink2); margin-top: 6px; font-family: 'DM Mono', monospace; }

  /* ── Right col ── */
  /* fare breakdown */
  .fare-table { width: 100%; border-collapse: collapse; }
  .fare-table tr td { padding: 7px 0; font-size: 13px; border-bottom: 1px solid var(--border); }
  .fare-table tr:last-child td { border-bottom: none; }
  .fare-table .label { color: var(--ink2); }
  .fare-table .val { text-align: right; font-family: 'DM Mono', monospace; font-size: 12px; color: var(--ink); }
  .fare-total-row td { padding-top: 12px; border-top: 2px solid var(--ink); font-weight: 700; font-size: 15px; }
  .fare-total-row .label { color: var(--ink); }
  .fare-total-row .val { font-family: 'Playfair Display', serif; font-size: 20px; color: var(--accent); }

  /* cancellation table */
  .cancel-table { width: 100%; border-collapse: collapse; font-size: 11px; }
  .cancel-table th { background: var(--paper); padding: 6px 10px; font-weight: 600; text-align: left; color: var(--ink2); border: 1px solid var(--border); font-size: 10px; text-transform: uppercase; letter-spacing: 1px; }
  .cancel-table td { padding: 6px 10px; border: 1px solid var(--border); color: var(--ink2); }
  .cancel-table td:last-child { text-align: right; font-weight: 600; font-family: 'DM Mono', monospace; color: var(--red); }

  /* policies */
  .policy-item { display: flex; align-items: flex-start; gap: 8px; font-size: 11px; color: var(--ink3); margin-bottom: 6px; line-height: 1.5; }
  .policy-dot { width: 4px; height: 4px; background: var(--accent2); border-radius: 50%; flex-shrink: 0; margin-top: 5px; }

  /* ── Footer ── */
  .inv-footer {
    background: var(--paper);
    border-top: 1px solid var(--border);
    padding: 16px 36px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
  }
  .footer-meta { display: flex; gap: 28px; flex-wrap: wrap; }
  .footer-item { font-size: 11px; color: var(--ink3); }
  .footer-item b { color: var(--ink); font-weight: 500; display: block; font-size: 12px; }
  .footer-brand { font-size: 11px; color: var(--ink3); }
  .footer-brand strong { color: var(--ink2); }

  /* watermark for cancelled */
  .cancelled-watermark {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-30deg);
    font-family: 'Playfair Display', serif;
    font-size: 80px;
    color: rgba(139,26,26,0.08);
    font-weight: 700;
    pointer-events: none;
    z-index: 0;
    letter-spacing: 10px;
    white-space: nowrap;
  }


`;

// ── Icons (inline SVG) ────────────────────────────────────────────────────────
const IconBus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="22" height="16" rx="2"/><path d="M1 9h22M7 19v2M17 19v2"/></svg>
);
const IconUser = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
);
const IconMap = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
);
const IconRupee = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 3h12M6 8h12M6 8a6 6 0 0 0 0 12h4l6-12"/></svg>
);
const IconShield = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
);
const IconPrint = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
);
const IconBack = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
);
const IconX = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
);
const IconClock = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
);
const IconPhone = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12 19.79 19.79 0 0 1 1.08 3.4 2 2 0 0 1 3.06 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z"/></svg>
);
const IconInfo = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
);

// ── Main Component ───────────────────────────────────────────────────────────
const FlightInvoice = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const invoiceRef = useRef(null);
  const guestUserId = typeof localStorage !== "undefined" ? localStorage.getItem("guestUserId") : null;

  const handleDownloadPDF = async () => {
    setIsGeneratingPdf(true);
    try {
      const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
        import("https://cdn.skypack.dev/html2canvas@1.4.1"),
        import("https://cdn.skypack.dev/jspdf@2.5.1"),
      ]);
      const el = invoiceRef.current;
      const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pdfW = pdf.internal.pageSize.getWidth();
      const pdfH = (canvas.height * pdfW) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfW, pdfH);
      pdf.save(`flight-ticket-${ticket?.id || "invoice"}.pdf`);
    } catch (err) {
      console.error("PDF generation failed:", err);
      Swal.fire({ title: "PDF Failed", text: "Could not generate PDF. Please try again.", icon: "error" });
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  useEffect(() => {
    if (!ticketId || !guestUserId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios.get(`${baseurl}getFlightBookingById/${ticketId}/${guestUserId}`)
      .then(r => {
        if (r.data.status === 'success' && r.data.booking) {
          setTicket(r.data.booking);
        } else {
          console.warn("Booking lookup failed:", r.data.message);
        }
      })
      .catch(err => {
        console.error("Pipeline failure executing record lookup:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [ticketId, guestUserId]);

  const handleCancelTicket = async () => {
    const result = await Swal.fire({
      title: "Cancel Flight Booking?",
      text: "This action cannot be undone. Cancellation charges will apply based on the airline policy.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#8b1a1a",
      cancelButtonColor: "#1a4a6b",
      confirmButtonText: "Yes, cancel it",
      cancelButtonText: "Keep booking",
    });
    if (!result.isConfirmed) return;
    setIsCancelling(true);
    try {
      const payload = { 
        bookingId: ticket.id, 
        pnr: ticket.response_payload?.rawResponse?.CommitBooking?.BookingDetails?.PNR, 
        guestUserId 
      };
      const res = await axios.post(`${baseurl}cancelFlightTicketGuest`, payload);
      if (res.data.status === "success") {
        await Swal.fire({ title: "Cancelled!", text: "Flight cancellation workflow initialized successfully.", icon: "success" });
        window.location.reload();
      }
    } catch (err) {
      Swal.fire({ title: "Failed", text: err.response?.data?.error || "Unexpected error processing cancellation request.", icon: "error" });
    } finally { setIsCancelling(false); }
  };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#3d4f5c" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 13, letterSpacing: 3, textTransform: "uppercase", opacity: .5 }}>Loading Flight Invoice…</div>
      </div>
    </div>
  );

  if (!ticket) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 12, opacity: .15 }}>✈️</div>
        <div style={{ fontWeight: 600, color: "#3d4f5c" }}>Flight Ticket Not Found</div>
        <button onClick={() => window.history.back()} style={{ marginTop: 16, padding: "8px 20px", background: "#1a4a6b", color: "white", border: "none", borderRadius: 6, cursor: "pointer" }}>Go Back</button>
      </div>
    </div>
  );

  // ── Safely Parse Complex Destructured Mappings from Flight Payload ──────────
  const flightDetails = ticket.additional_data?.flight?.JourneyList?.FlightDetails?.Details?.[0]?.[0] || {};
  const searchData = ticket.additional_data?.searchData || {};
  const priceData = ticket.additional_data?.flight?.JourneyList?.Price || {};
  const addons = ticket.additional_data?.selectedAddons || {};
  const commitDetails = ticket.response_payload?.rawResponse?.CommitBooking?.BookingDetails || {};
  
  // Passengers data extracted from API structural path
  const passengers = commitDetails.PassengerDetails || [];

  const isCancelled = ticket.status === "CANCELLED" || commitDetails.status === "CANCELLED";
  const durationMins = parseInt(flightDetails.Duration || 0);

  return (
    <>
      <style>{CSS}</style>
      <div className="inv-page" style={{ marginTop: "100px" }}>
        
        {/* Top bar control utilities */}
        <div className="top-bar no-print">
          <button className="btn btn-ghost" onClick={() => window.history.back()}><IconBack /> Back</button>
          <div style={{ display: "flex", gap: 10 }}>
            {!isCancelled && (
              <button className="btn btn-danger" onClick={handleCancelTicket} disabled={isCancelling}>
                {isCancelling ? "Processing..." : <><IconX /> Cancel Flight</>}
              </button>
            )}
            <button className="btn btn-primary" onClick={handleDownloadPDF} disabled={isGeneratingPdf}>
              <IconPrint /> {isGeneratingPdf ? "Generating…" : "Download PDF"}
            </button>
          </div>
        </div>

        <div className="invoice" ref={invoiceRef}>
          {/* ── Header Area ── */}
          <div className="inv-header">
            <div>
              <div className="brand-name">TopAirView</div>
              <div className="brand-sub">Solutions Limited</div>
              <div className="brand-contact">
                ✉ a2zyatra2012@gmail.com<br />
                ⌂ Bholagiri Road, Haridwar, UK 249401
              </div>
            </div>
            <div className="doc-meta">
              <div className="doc-title">Electronic Flight Ticket</div>
              <div className="doc-tin">Booking ID: {commitDetails.BookingId || ticket.id}</div>
              <div>
                <span className={`status-chip ${isCancelled ? "chip-cancelled" : "chip-booked"}`}>
                  ● {ticket.status || "SUCCESS"}
                </span>
              </div>
            </div>
          </div>

          {/* ── Journey Route Strip ── */}
          <div className="journey-strip">
            <div>
              <div className="city-label">Departure ({flightDetails.Origin?.AirportCode || searchData.fromCode})</div>
              <div className="city-name">{flightDetails.Origin?.CityName || "Origin"}</div>
              <div className="city-time">{minsToTime(flightDetails.Origin?.DateTime)}</div>
              <div className="city-date">{formatDOJ(flightDetails.Origin?.DateTime)}</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 4 }}>{flightDetails.Origin?.AirportName}</div>
            </div>
            <div className="journey-mid">
              <div className="dur-pill"><IconClock /> {Math.floor(durationMins / 60)}h {durationMins % 60}m</div>
              <div className="route-line"></div>
              <div style={{ fontSize: 10, color: "#7a8fa0", letterSpacing: 1 }}>{searchData.tripType?.toUpperCase() || "DIRECT"}</div>
            </div>
            <div>
              <div className="city-label">Arrival ({flightDetails.Destination?.AirportCode || searchData.toCode})</div>
              <div className="city-name">{flightDetails.Destination?.CityName || "Destination"}</div>
              <div className="city-time">{minsToTime(flightDetails.Destination?.DateTime)}</div>
              <div className="city-date">{formatDOJ(flightDetails.Destination?.DateTime)}</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 4 }}>{flightDetails.Destination?.AirportName}</div>
            </div>
          </div>

          {/* ── Operator / Operational Metadata Bar ── */}
          <div className="operator-bar">
            <div className="op-item">
              <span className="op-label">Airline Carrier</span>
              <span className="op-value">{flightDetails.OperatorName || "IndiGo"}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Flight Number</span>
              <span className="op-value">{flightDetails.OperatorCode}-{flightDetails.FlightNumber}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Airline PNR</span>
              <span className="op-value mono" style={{color: '#2b6cb0', fontWeight: 'bold'}}>{commitDetails.PNR || "N/A"}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Class</span>
              <span className="op-value">{searchData.cabin || "Economy"}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Assigned Seat</span>
              <span className="op-value">{addons.selectedSeat?.SeatNumber || "Check-In Required"}</span>
            </div>
          </div>

          {/* ── Document Structural Layout Body ── */}
          <div className="inv-body">
            {/* Left Layout Information Block */}
            <div>
              {/* Passengers Container Layout */}
              <div className="section">
                <div className="sec-title"><IconUser /> Passenger Details</div>
                {passengers.length > 0 ? (
                  passengers.map((pax, idx) => (
                    <div className="pax-card" key={idx}>
                      <div>
                        <div className="pax-name">{pax.Title} {pax.FirstName} {pax.LastName}</div>
                        <div className="pax-meta">Type: {pax.PassengerType === "ADT" ? "Adult" : pax.PassengerType} | Ticket ID: {pax.TicketId}</div>
                      </div>
                      <div className="pax-seat">
                        <span className="seat-lbl">Seat</span>
                        <span className="seat-num">{idx === 0 && addons.selectedSeat?.SeatNumber ? addons.selectedSeat.SeatNumber : "Auto"}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pax-card"><div className="pax-name">Passenger Information Not Rendered</div></div>
                )}
              </div>

              {/* Terminal Flight Information Layout */}
              <div className="section">
                <div className="sec-title"><IconMap /> Airport Terminals & Stations</div>
                <div className="station-box boarding">
                  <div className="station-type boarding">▲ Departure Airport</div>
                  <div className="station-name">{flightDetails.Origin?.AirportName || flightDetails.Origin?.AirportName}</div>
                  <div className="station-addr">Terminal: {flightDetails.Origin?.Terminal || "Main Terminal Area"}</div>
                </div>
                <div className="station-box dropping">
                  <div className="station-type dropping">▼ Destination Arrival Airport</div>
                  <div className="station-name">{flightDetails.Destination?.AirportName || flightDetails.Destination?.AirportName}</div>
                  <div className="station-addr">Terminal: {flightDetails.Destination?.Terminal || "Main Terminal Area"}</div>
                </div>
              </div>

              {/* Selected Ancillary Addons */}
              {(addons.selectedMeal || addons.selectedBaggage) && (
                <div className="section">
                  <div className="sec-title"><IconInfo /> Selected Ancillaries & Meals</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {addons.selectedMeal && (
                      <div style={{ background: "#f7fafc", border: "1px solid #e2e8f0", borderRadius: 4, padding: "8px 12px" }}>
                        <div style={{ fontSize: 9, color: "#718096", textTransform: "uppercase", marginBottom: 2 }}>In-Flight Meal Preference</div>
                        <div style={{ fontSize: 12, fontWeight: 500 }}>{addons.selectedMeal.Description}</div>
                      </div>
                    )}
                    {addons.selectedBaggage && (
                      <div style={{ background: "#f7fafc", border: "1px solid #e2e8f0", borderRadius: 4, padding: "8px 12px" }}>
                        <div style={{ fontSize: 9, color: "#718096", textTransform: "uppercase", marginBottom: 2 }}>Excess Checked Baggage</div>
                        <div style={{ fontSize: 12, fontWeight: 500 }}>+{addons.selectedBaggage.Weight} Allowance</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Right Layout Calculations Component Block */}
            <div>
              {/* Financial Breakdowns Container */}
              <div className="section">
                <div className="sec-title"><IconRupee /> Fare Breakdown</div>
                <div style={{ border: "1px solid #e2e8f0", borderRadius: 6, padding: "16px", background: "#fff" }}>
                  <table className="fare-table">
                    <tbody>
                      <tr>
                        <td className="label">Airline Base Fare</td>
                        <td className="val">₹{fmt(priceData.PriceBreakup?.BasicFare || parseFloat(ticket.amount) - (priceData.PriceBreakup?.Tax || 0))}</td>
                      </tr>
                      <tr>
                        <td className="label">Aviation Taxes & Fees (GST)</td>
                        <td className="val">₹{fmt(priceData.PriceBreakup?.Tax || 0)}</td>
                      </tr>
                      {addons.selectedMeal?.Price > 0 && (
                        <tr>
                          <td className="label">Pre-booked Meal Service</td>
                          <td className="val">₹{fmt(addons.selectedMeal.Price)}</td>
                        </tr>
                      )}
                      {addons.selectedBaggage?.Price > 0 && (
                        <tr>
                          <td className="label">Ancillary Baggage Fee</td>
                          <td className="val">₹{fmt(addons.selectedBaggage.Price)}</td>
                        </tr>
                      )}
                      <tr className="fare-total-row">
                        <td className="label">Total Amount Paid</td>
                        <td className="val">₹{fmt(ticket.amount)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Static Policy Guidelines Frame Section */}
              <div className="section">
                <div className="sec-title"><IconShield /> Fare Regulations & Rules</div>
                <table className="cancel-table">
                  <thead>
                    <tr>
                      <th>Rule Type</th>
                      <th>Policy Conditions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Cancellation</td>
                      <td>{ticket.additional_data?.flight?.JourneyList?.Attr?.FareInclusions?.cancellation || "Charges Apply"}</td>
                    </tr>
                    <tr>
                      <td>Reissue / Changes</td>
                      <td>{ticket.additional_data?.flight?.JourneyList?.Attr?.FareInclusions?.reissue || "Charges Apply"}</td>
                    </tr>
                    <tr>
                      <td>Cabin Baggage</td>
                      <td>{flightDetails.Attr?.CabinBaggage || "7 KG"} Max per pax</td>
                    </tr>
                    <tr>
                      <td>Check-In Baggage</td>
                      <td>{flightDetails.Attr?.Baggage || "15 Kilograms"} Allowance</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* ── Invoice Footer Blocks ── */}
          <div className="inv-footer">
            <div className="footer-meta">
              <div className="footer-item"><b>Payment State</b>{ticket.payment_details?.state?.toUpperCase() || "CAPTURED"}</div>
              <div className="footer-item"><b>Method</b>{ticket.payment_details?.payment_method || "WALLET"}</div>
              <div className="footer-item"><b>Issued At</b>{new Date(ticket.created_at).toLocaleString("en-IN")}</div>
            </div>
            <div className="footer-brand">
              <strong>© 2026 TopAirView Solutions Limited</strong><br />
              Electronic Manifest. Generated by computer system. No Signature Required.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightInvoice;